
import viMessages from '../locales/vi-VI';

const ViLang = {
    messages: {
        ...viMessages
    },
    locale: 'vi-VI',
   
};
export default ViLang;